import {Model} from '@vuex-orm/core';
import moment from 'moment';

export default class WikiPage extends Model {

    static entity = 'wiki_page';
    static primaryKey = 'id_wiki_page';

    static fields() {
        return {
            id_wiki_page: this.number(null),
            title: this.attr(""),
            content: this.attr(""),
            creator_name: this.attr(null),
            last_editor_name: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            id_group: this.attr(null),
            id_creator: this.attr(null),
            id_last_editor: this.attr(null),
            id_parent_page: this.attr(null),
            id_predecessor: this.attr(null),
            attachments: this.attr([]),
        };
    }

    get updatedAtString() {
        return moment(this.updated_at).format("DD.MM.YYYY");
    }
}